import {apolloClient} from '@/setup/apollo-setup';
// import axios from "axios";
import axios from "@/setup/axios-setup";
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {config} from "@/utils/upload";
import {
  GET_CLASSASSIGNMENT,
  GET_CLASSASSIGNMENTS,
  GET_CLASSASSIGNMENTS_BY_FILTER,
  CHECK_CAN_DELETE,
  ADD_CLASSASSIGNMENT,
  UPDATE_CLASSASSIGNMENT,
  DELETE_CLASSASSIGNMENT
} from '@/queries/modules/courses/class-assignment';

export async function getClassAssignments(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSASSIGNMENTS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassAssignments', data.getClassAssignments);
      context.commit('setSuccess', null);
      return data.getClassAssignments
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassAssignmentsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSASSIGNMENTS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.getClassAssignmentsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassAssignment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSASSIGNMENT,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setClassAssignment', data.getClassAssignment);
      context.commit('setSuccess', null);
      return data.getClassAssignment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function checkCanDelete(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: CHECK_CAN_DELETE,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.checkCanDelete
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addClassAssignment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_CLASSASSIGNMENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const classAssignments = [...context.state.classAssignments];
      classAssignments.push(data.addClassAssignment);
      context.commit('setClassAssignments', classAssignments);
      context.commit('setSuccess', newItemSuccess(data.addClassAssignment.topicLocal));

      return data.addClassAssignment;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateClassAssignment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_CLASSASSIGNMENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.classAssignments.findIndex(item => item.id === data.updateClassAssignment.id);
      const classAssignments = [
        ...context.state.classAssignments.slice(0, index),
        data.updateClassAssignment,
        ...context.state.classAssignments.slice(index + 1)
      ];
      context.commit('setClassAssignments', classAssignments);
      context.commit('setSuccess', updateItemSuccess(data.updateClassAssignment.topicLocal));

      return data.updateClassAssignment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteClassAssignment(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_CLASSASSIGNMENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.classAssignments.findIndex(item => item.id === data.deleteClassAssignment.id);
      const classAssignments = [
        ...context.state.classAssignments.slice(0, index),
        ...context.state.classAssignments.slice(index + 1)
      ];
      context.commit('setClassAssignments', classAssignments);
      context.commit('setSuccess', deleteItemSuccess(data.deleteClassAssignment.topicLocal));

      return data.deleteClassAssignment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function uploadAssignment(context, payload){
  const rsc = JSON.parse(localStorage.getItem("rsc"));
  let entity, stage
  if (rsc) {
    entity = rsc.e_code;
    stage = rsc.r_stage;
  }
  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('file1', payload.file1);
  formData.append('ext', payload.file.name.substring([payload.file.name.lastIndexOf('.') + 1]));
  formData.append('timestamp', payload.file.lastModified);
  formData.append('operationName', payload.operationName);
  // formData.append('stage', payload.stage);
  // formData.append('entity', payload.entity);
  formData.append('stage', stage);
  formData.append('entity', entity);
  formData.append('authorization', payload.authorization);
  formData.append('app', payload.app);

  try {
    const result = await axios({
      url: config.url.uploadFiles,
      method: 'post',
      headers: {
        'content-type': 'multipart/form-data'
      },
      data: formData,
    });

    const {data} = await result;

    return data;
  } catch (e) {
    // commit('setError', error(e));
    return null;
  }

}

